// presigned URL API 발급 제한 조건 : 5MB, 10개
export const MAX_UPLOAD_IMAGE_SIZE = 5 * 1024 * 1024;
export const MAX_UPLOAD_IMAGE_COUNT = 10;

export const UPLOAD_ERROR_TYPE = {
  MAX_UPLOAD_COUNT: `파일 갯수를 확인해주세요. (최대 ${MAX_UPLOAD_IMAGE_COUNT}개)`,
  MAX_SIZE: '파일 크기를 확인해주세요. (최대 2MB)',
};

export const DEFAULT_CONFIG = {
  height: 600,
  license: process.env.REACT_APP_JODIT_EDITOR_LICENSE_KEY || '',
  readonly: false,
  loadExternalConfig: false,
  uploader: {
    url: '*',
    insertImageAsBase64URI: false,
    isSuccess: () => true,
    process: () => ({ files: [] }),
    getMessage: false,
  },
  filebrowser: {
    url: '*',
  },
};
